import { render, staticRenderFns } from "./FullApp.vue?vue&type=template&id=5bbbebde&scoped=true&"
import script from "./FullApp.vue?vue&type=script&lang=js&"
export * from "./FullApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbbebde",
  null
  
)

export default component.exports